/**
 * Ryan O'Dowd
 * 2024-11-16
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    container: {
      display: 'flex',
      paddingVertical: globalScale * 8,
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.primaryLight : colors.primaryDark,
    },
  };
};

export default getStyles;
